import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbCryptoMarket = () => {
  return (
    <div
      className="ht__bradcaump__area_market"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container_market">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>Trade the World’s Leading Cryptocurrencies — Instantly</h1>
              <p>
                Experience the future of trading with lightning-fast execution,
                transparent pricing, and 24/7 access to top crypto assets, all
                powered by The Pips.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Start Trading Crypto
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbCryptoMarket.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbCryptoMarket;
